import cn from 'clsx'

import { CloseIcon, SendToEmailIcon } from '@App/static/icons/ArrowIcons'

import { Button } from '../../controls/Button'
import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'

import s from './styles.module.scss'

export const SendReportModal = ({ isOpen, setIsOpen }: ModalTypes) => {
  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={s.container}>
        <div className={s.header}>
          <CloseIcon className={s.closeIcon} onClick={setIsOpen} />
        </div>
        <div className={s.content}>
          <div className={s.top}>
            <SendToEmailIcon className={s.sendToEmailIcon} />
            <div className={s.title}>The requested report will be sent to your email</div>
          </div>
          <div className={s.bottom}>
            <Button className={cn(s.btn, s.outlined, s.small)} onClick={setIsOpen}>
              Cancel
            </Button>
            <Button className={cn(s.btn, s.small)} onClick={setIsOpen}>
              Send
            </Button>
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}
